import { Tracking, CookieType } from "../helpers/enums";
import { objectHasKeys } from "../helpers/util";

interface IDataLayerEventData {
  [key: string]: any;
}

interface IDataLayer {
  eventName?: string;
  eventData?: IDataLayerEventData;
}

export const getGlobalTrackingVars = () => {
  const languageCookie = document.cookie.match(
    new RegExp(`(^| )${CookieType.LANGUAGE}=([^;]+)`)
  );

  const currencyCookie = document.cookie.match(
    new RegExp(`(^| )${CookieType.CURRENCY}=([^;]+)`)
  );

  const sessionIdCookie = document.cookie.match(
    new RegExp(`(^| )${CookieType.SESSION_ID}=([^;]+)`)
  );

  const globalVars = () => {
    const { user_is_logged_in, profile_id, page_code, ...restOfVars } =
      window["trackingVarsGlobal"] ?? {};

    const pageCodeToUse = () => {
      if (page_code) {
        return page_code;
      } else {
        if (window.location.href.indexOf("/404") > -1) {
          return "error_404";
        } else if (window.location.href.indexOf("/500") > -1) {
          return "error_500";
        }
      }
    };

    if (user_is_logged_in === "True") {
      return {
        ...restOfVars,
        page_code: pageCodeToUse(),
        user_id: profile_id,
        user_is_logged_in: true,
      };
    } else {
      return {
        ...restOfVars,
        page_code: pageCodeToUse(),
        user_is_logged_in: false,
      };
    }
  };

  const cityVars = () =>
    objectHasKeys(window?.["trackingVarsCity"])
      ? window["trackingVarsCity"]
      : {};

  const hotelVars = () =>
    objectHasKeys(window?.["trackingVarsHotel"])
      ? window["trackingVarsHotel"]
      : {};

  const guestServicesVars = () =>
    objectHasKeys(window?.["trackingVarsGuestService"])
      ? window["trackingVarsGuestService"]
      : {};

  const viewBookingVars = () =>
    objectHasKeys(window?.["trackingVarsViewBooking"])
      ? window["trackingVarsViewBooking"]
      : {};

  const cookieVars = () => ({
    browsing_language: languageCookie
      ? languageCookie[2].toUpperCase() === "EN-GB"
        ? "EN"
        : languageCookie[2].toUpperCase()
      : "EN",
    display_currency: currencyCookie ? currencyCookie[2].toUpperCase() : "EUR",
    sc_session_id: sessionIdCookie ? sessionIdCookie[2] : "NO_COOKIE_FOUND",
  });

  return {
    ...globalVars(),
    ...cityVars(),
    ...hotelVars(),
    ...guestServicesVars(),
    ...viewBookingVars(),
    ...cookieVars(),
  };
};

const pushToDataLayer = (data: IDataLayerEventData) => {
  const dataWithGlobals = {
    event_timestamp: Math.floor(Date.now() / 1000),
    ...getGlobalTrackingVars(),
    ...data,
  };

  if (window["dataLayer"]) {
    window["dataLayer"].push(dataWithGlobals);
  }
};

export const trackEvent = ({
  eventName = Tracking.TRACK_EVENT,
  eventData,
}: IDataLayer) => pushToDataLayer({ event: eventName, ...eventData });

export const trackPageView = ({
  eventName = Tracking.PAGE_VIEW,
  eventData,
}: IDataLayer) => pushToDataLayer({ event: eventName, ...eventData });

export const abandonBrowseIsActive = () => !!window?.["dmPt"]?.initialized;
